import * as Yup from 'yup';

const requiredText = 'Это обязательное поле';
const emailText = 'Введите корректный email адрес';

export const styleCustomSelect = {
  container: (provided: Record<string, any>) => ({
    ...provided,
    width: '100%',
    cursor: 'pointer',
    margin: 0,
    fontSize: 16,
    boxShadow: 'none',
  }),
  control: (provided: Record<string, any>) => ({
    ...provided,
    minHeight: 48,
    width: '100%',
    cursor: 'pointer',
    fontSize: 16,
    boxShadow: 'none',
  }),
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  multiValue: (provided: Record<string, any>) => ({
    ...provided,
    borderRadius:32,
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
}

export enum TYPE_MODAL_TASK {
  ORDER,
  USER,
  CALL_INFO
}

export const createTaskModalSchema = Yup.object().shape({
  title: Yup.string().required(requiredText),
  email: Yup.string().email(emailText),
  user: Yup.mixed().when('groups', {
    is: (groups: any) => !groups,
    then: Yup.mixed().required('Необходимо указать исполнителя или группу')
  }),
  phone: Yup.string().nullable().phone('', true, 'Неккоректный телефон'),
})